import dayjs from 'dayjs';
import { ReactNode } from 'react';
import { BsThreeDots } from 'react-icons/bs';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import { FaCircleXmark } from 'react-icons/fa6';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { InfiniteScroll } from '../../../../../../components/infinite-scroll/infinite-scroll';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { useLang } from '../../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../../hooks/use-modal-params';
import { StatementStatusType } from '../../../../../../store/api/statements-api';
import { useStatementsStore } from '../../../../../../store/use-statements-store';
import { statementTypeTitleMap, statusTitleMap } from '../use-statements';
import s from './statements-cards.module.css';

const statusIconMap: Record<StatementStatusType, ReactNode> = {
  APPROVED: <FaCheckCircle size={20} color="#1A8754" />,
  REJECTED: <FaCircleXmark size={20} color="#DC3545" />,
  IDLE: <FaExclamationCircle size={20} color="#227CF1" />,
};

export const StatementsCards = () => {
  const { t, getLocale } = useLang();
  const { list, isLoading } = useStatementsStore();
  const updateStatementStatus = useModalParams('updateStatementStatus');

  if (!list?.length && !isLoading) {
    return <div>{t('Здесь пока нет заявлений')}</div>;
  }

  return (
    <ul className={s.feature}>
      {list?.map((item) => {
        const period = `${dayjs(item.start_date).format('DD.MM')} - ${dayjs(item.end_date).format(
          'DD.MM',
        )}`;

        return (
          <li key={item.id} className={s.item}>
            <div className={s.top}>
              <div className={s.status}>
                {statusIconMap[item.status]}
                <span>
                  <div className={s.title}>{t('Статус')}</div>
                  <div className={s.subtitle}>{t(statusTitleMap[item.status])}</div>
                </span>
              </div>

              <HasAccess service="staff" permissions={['write']}>
                <IconButton
                  variant="secondary"
                  size="sm"
                  disabled={isLoading}
                  className={s.actionsButton}
                  onClick={() =>
                    updateStatementStatus.handleOpenModal({ statement: JSON.stringify(item) })
                  }
                >
                  <BsThreeDots />
                </IconButton>
              </HasAccess>
            </div>

            <div className={s.main}>
              <span>
                <span className={s.title} style={{ marginRight: 17 }}>
                  {t('Должность')}
                </span>

                <span className={s.subtitle}>
                  {item.staff.tags.map((tag) => tag.value).join(', ')}
                </span>
              </span>

              <div className={s.name}>
                {getLocale(item.staff.surname)} {getLocale(item.staff.name)}
              </div>
            </div>

            <div className={s.bottom}>
              <div>
                <div className={s.title}>{t('Тип')}</div>
                <div className={s.subtitle}>{t(statementTypeTitleMap[item.type])}</div>
              </div>

              <div>
                <div className={s.title}>{t('Период')}</div>
                <div className={s.subtitle}>{period}</div>
              </div>
            </div>
          </li>
        );
      })}

      <InfiniteScroll onEnterView={() => {}} />
    </ul>
  );
};
